import React from 'react'

export const InfoBox = ({ message }: { message: string }) => {
  return (
    <div data-bind='visible: isError' className='modalSection m1em text-center'>
      <span className='alertBox__icon alertBox__icon--info'></span>
      <div className='pb5 pt10 fz-16 faux-strong'></div>
      <div className='alertBox__text' data-tid-alertboxmessage=''>
        <div className='dib phalfem'>{message}</div>
        <div className='dib'>Please try again later.</div>
        <div className='pb5 pt10 fz-16'>&nbsp;</div>
      </div>
    </div>
  )
}
